'use strict';

var cart = require('../cart/cart');

var updateMiniCart = true;
var isPopoverOpen = false;

module.exports = function () {
    cart();

    $('.minicart').on('count:update', function (event, count) {
        if (count && $.isNumeric(count.quantityTotal)) {
            $('.minicart .minicart-quantity').text(count.quantityTotal);
            $('.minicart .minicart-link').attr({
                'aria-label': count.minicartCountOfItems,
                title: count.minicartCountOfItems
            });
        }

        if (count.quantityTotal === 0) {
            isPopoverOpen = false;
            $('.minicart .popover').addClass('cc-minicart__popover--empty');
        }
        else {
            $('.minicart .popover').removeClass('cc-minicart__popover--empty');
        }
    });

    $('.minicart').on('mouseenter', function () {
        if (isPopoverOpen || $('.minicart .popover:hover').length) {
            return;
        }

        var url = $('.minicart').data('action-url');
        $('.minicart .popover').spinner().start();

        $.get(url, function (data) {
            $('.minicart .popover').empty().append(data);

            if($('.minicart .minicart-quantity').text().trim() === '0') {
                $('.minicart .popover').addClass('cc-minicart__popover--empty');
            } else {
                $('.minicart .popover').removeClass('cc-minicart__popover--empty');
            }

            $('.minicart .popover').addClass('show');
            $('.minicart .popover').spinner().stop();
            $('body').addClass('cc-popover-is-open');
            isPopoverOpen = true;
        });
    });

    $('.minicart, .minicart .popover').on('mouseenter', function () {
        clearTimeout($(this).data('timeoutId'));
    });

    $('.minicart, .minicart .popover').on('mouseleave', function () {
        var $this = $(this);
        var timeoutId = setTimeout(function () {
            if (!$('.minicart:hover').length && !$('.minicart .popover:hover').length && !$('body').hasClass('modal-open')) {
                $('.minicart .popover').removeClass('show');
                $('.cc-minicart').hide();
                $('body').removeClass('cc-popover-is-open');
                isPopoverOpen = false;
            }
        }, 200);
        $this.data('timeoutId', timeoutId);
    });

    $('body').on('product:afterAddToCart, cart:update', function () {
        updateMiniCart = true;
        isPopoverOpen = false;
    });
};